import { render, staticRenderFns } from "./TableNewStock.vue?vue&type=template&id=60870f64&scoped=true&"
import script from "./TableNewStock.vue?vue&type=script&lang=js&"
export * from "./TableNewStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60870f64",
  null
  
)

export default component.exports